<article class="grid-wrapper">
  @if (loading()) {
  <div class="state-row">
    <div class="spinner-wrapper">
      <app-spinner size="m" type="ripple" />
      <p>{{ 'pages.applications.states.loading' | translate }}</p>
    </div>
  </div>
  } @else if (applications().length === 0) {
  <div class="state-row">
    <span>{{ 'pages.applications.states.empty' | translate }}</span>
  </div>
  } @else {
  <app-responsive-table [items]="applications()" [columns]="columns()" [actions]="actions()" [maxInlineActions]="3"
    [trackBy]="trackByApplication" (actionSelected)="onActionSelected($event)" [paginated]="true" [page]="pageNumber()"
    [pageSize]="pageSize()" [totalItems]="totalItems()" (pageChange)="onPageChange($event)" />
  }
</article>
